export interface NotificationPreferences {
  inAppNotifications: boolean;
  emailNotifications: boolean;
  emailCriticalOnly: boolean;
  dealAlerts: boolean;
  portfolioAlerts: boolean;
  workflowAlerts: boolean;
  commentsAndMentions: boolean;
  teamUpdates: boolean;
  documentUpdates: boolean;
  weeklyDigest: boolean;
}

export type NotificationPreferenceKey = keyof NotificationPreferences;

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  inAppNotifications: true,
  emailNotifications: true,
  emailCriticalOnly: true,
  dealAlerts: true,
  portfolioAlerts: true,
  workflowAlerts: true,
  commentsAndMentions: true,
  teamUpdates: true,
  documentUpdates: true,
  weeklyDigest: true,
};

export function normalizeNotificationPreferences(
  value: unknown
): NotificationPreferences {
  const input = value && typeof value === 'object'
    ? value as Partial<NotificationPreferences> & Record<string, unknown>
    : {};

  return {
    ...DEFAULT_NOTIFICATION_PREFERENCES,
    ...input,
    inAppNotifications: input.inAppNotifications !== false,
    emailNotifications: input.emailNotifications !== false,
    emailCriticalOnly: input.emailCriticalOnly !== false,
    dealAlerts: input.dealAlerts !== false,
    portfolioAlerts: input.portfolioAlerts !== false,
    workflowAlerts: input.workflowAlerts !== false,
    commentsAndMentions: input.commentsAndMentions !== false,
    teamUpdates: input.teamUpdates !== false,
    documentUpdates: input.documentUpdates !== false,
    weeklyDigest: input.weeklyDigest !== false,
  };
}
